// extracted by mini-css-extract-plugin
export default {"after":"Header_after__MHinj"};